import styled from "react-emotion"
import PropTypes from "prop-types"

const Divider = styled("hr")`
    border: 1px solid ${props => props.theme.dividerColor};
    margin: ${props => props.theme[props.margin || "medium"]};
`

Divider.propTypes = {
    padding: PropTypes.oneOf(["xsmall", "small", "medium", "large", "xlarge", "none"]),
}

Divider.displayName = "Divider"
export default Divider



// WEBPACK FOOTER //
// ./src/ui/components/Divider.js